<template>
  <div class="new-application">
    <el-card class="box-card">
      <folded-panel infoName="基本信息">
        <div slot="content">
          <dynamic-form
            labelWidth="110px"
            :formConfig="formConfig"
            v-model="form"
            :showBtn="false"
            :disabled="!isEdit"
            ref="form"
          />
        </div>
      </folded-panel>
      <folded-panel infoName="详细计划">
        <div slot="content">
          <el-button v-if="canAddNode" size="small" type="primary" class="add-project" @click="addNode">新增阶段</el-button>
          <edit-data-table
            ref="planTable"
            :head="tableHead"
            :data.sync="tableData"
            :edit-rules="validRules"
            :tool-bar="{hidden: !canEdit, width: 120, fixed: 'right',label:'操作',align:'center' }"
            :config="{trigger: 'click', mode: 'row', activeMethod: activeMethod , autoClearActive: false }"
            :editable="isEdit"
            :showAdd="false"
            max-height="400px"
          >
            <template #insert="scope">
              <span v-if="!isEdit">无</span>
              <el-button
                type="text"
                icon="el-icon-circle-plus-outline"
                @click="insertRow(scope)"
                v-if="isEdit"
              ></el-button>
            </template>
            <template #toolbar="scope">
              <el-popover
                :ref="scope.$index + 'b'"
                placement="top"
                width="180"
                v-if="scope.row.surer === 1">
                <p>确定完成该任务数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    size="mini"
                    type="text"
                    @click="$refs[scope.$index + 'b'].doClose()"
                  >取消</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="primaryList(scope.row.id, scope)"
                  >确定
                  </el-button>
                </div>
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-check"
                  slot="reference"
                ></el-button>
              </el-popover>
              <el-popover
                :ref="scope.$index + 'a'"
                placement="top"
                width="180"
                v-if="showDel(scope)"
                >
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    size="mini"
                    type="text"
                    @click="$refs[scope.$index + 'a'].doClose()"
                  >取消</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="delMilestonePlans(scope.row.id, scope)"
                  >确定
                  </el-button>
                </div>
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-delete"
                  slot="reference"
                ></el-button>
              </el-popover>
              <el-button v-if="scope.row.id && !isEdit && scope.row.milestoneNodeEntity.isEnabled" type="text" size="mini" @click="taskDecomposition(scope)">
                任务分解
              </el-button>
            </template>
            <template #projectNodeEntity="{ row }">
              <span>{{
                row.projectNodeEntity ? row.projectNodeEntity.name : ""
              }}</span>
            </template>
            <template #projectNodeEntityEdit="{ row }">
              <data-box
                hostUrl="/bsProjectNode"
                :props="{ label: 'name', value: 'id' }"
                v-model="row.projectNodeEntity"
                :tableColumn="projecdNodeHead"
                :multiple="false"
                @confirm="
                  (val) => {
                    row.projectNode = val.id;
                  }
                "
              ></data-box>
            </template>
            <template #keyOutObjectEntity="{ row }">
              <span
                v-for="(item, index) in row.keyOutsList"
                :key="item.id">
                {{ item.name}}{{index &lt; row.keyOutsList.length-1 ? ',' : ''}}
              </span>
            </template>
            <template #keyOutObjectEntityEdit="{ row }">
              <data-box
                hostUrl="/bsKeyOuts"
                :props="{ label: 'name', value: 'id' }"
                v-model="row.keyOutsListArr"
                :tableColumn="headLevels"
                :multiple="true"
                @confirm="
                  (val) => {
                    row.keyOutsList = val;
                    if (val) {
                      const newArr = val.map((item) => {
                        return item.id;
                      });
                      row.keyOutObject = newArr.join() ? newArr.join() : null;
                    }
                  }
                "
              />
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="计划变更记录" v-if="tableChangeData.length">
        <div slot="content">
          <edit-data-table
            :head="changeHead"
            :data="tableChangeData"
            :tool-bar="{hidden: true }"
            :editable="false"
            :showAdd="false"
            max-height="400px"
          >
          <template #projectNodeEntity="{ row }">
              <span>{{
                row.projectNodeEntity ? row.projectNodeEntity.name : ""
              }}</span>
            </template>
            <template #keyOutObjectEntity="{ row }">
              <span
                v-for="(item, index) in row.keyOutsList"
                :key="item.id">
                {{ item.name}}{{index &lt; row.keyOutsList.length-1 ? ',' : ''}}
              </span>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="附件">
        <div slot="content">
          <el-upload
            v-if="isEdit"
            class="upload-demo"
            :action="actionUrl"
            :headers="uploadHeaders"
            :on-success="handleSuccess"
            :file-list="fileId"
            :show-file-list="true"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-preview="preview"
            style="margin: 14px"
          >
            <el-button size="small" type="primary">附件上传</el-button>
          </el-upload>
          <div class="file-box" v-if="!isEdit">
            <div v-for="item in fileId" :key="item.id" class="file-item">
              <el-button @click="preview(item)">{{ item.name }}</el-button>
              <!-- <i class="el-icon-close file-close" v-if="isEdit" @click="delFile(item,index)"></i> -->
            </div>
          </div>
        </div>
      </folded-panel>
      <div class="btn-warp">
         <el-button class="btn-cancel" v-if="canSave && canEdit" :loading="loading" @click="save(1)">保存</el-button>
        <el-button
          v-permission="['project-plan:node:edit']"
          class="btn-submit"
          v-if="isEdit && canEdit"
          :loading="loading"
          @click="submit(2)"
          >提交</el-button
        >
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </el-card>
    <drag-dialog
      :show="stepShow"
      :title="'审批人选择'"
      :width="'25%'"
      @close="stepShow = false">
      <PersonStep
        ref="personStepRef"
        :data="personStepData"
        @submit="submitConfirm"
        @close="stepShow = false"
      ></PersonStep>
    </drag-dialog>
    <drag-dialog
        :show.sync="addTaskDialog"
        title="任务分解"
        width="1000px"
        :loading='taskLoading'
        @close="addTaskDialog = false"
      >
      <edit-data-table
        ref="taskTable"
        :head="taskHead"
        :data.sync="taskData"
        :editable="true"
        :edit-rules="taskvalidRules"
        :tool-bar="{hidden: false, fixed: 'right',label:'操作',align:'center' }"
        :config="{ trigger: 'click', mode: 'cell',activeMethod: taskActiveMethod, autoClearActive: false }"
        :showAdd="true"
        max-height="400px"
        :loading='taskLoading'
      >
      <template #toolbar="scope">
        <el-popover
          :ref="scope.$index + 'task'"
          placement="top"
          width="180"
        >
          <p>确定删除本条数据吗？</p>
          <div style="text-align: right; margin: 0">
            <el-button
              size="mini"
              type="text"
              @click="$refs[scope.$index + 'task'].doClose()"
            >取消</el-button>
            <el-button
              type="primary"
              size="mini"
              @click="delTaskDetails(scope)"
            >确定
            </el-button>
          </div>
          <el-button
            type="text"
            size="mini"
            icon="el-icon-delete"
            slot="reference"
          ></el-button>
        </el-popover>
      </template>
      <template #taskReceiverPerson="{ row }">
        <span>{{
          row.taskReceiverPerson ? row.taskReceiverPerson.name : ""
        }}</span>
      </template>
      <template #taskReceiverPersonEdit="{ row }">
        <data-box
          hostUrl="/bizTaskDecomposition/getPersonByProjectCode"
          :props="{ label: 'name', value: 'id' }"
          :extendParms="taskPersonCode"
          v-model="row.taskReceiverPerson"
          :tableColumn="persionNodeHead"
          :multiple="false"
          @confirm="
            (val) => {
              row.taskReceiver = val.id
            }
          "
        ></data-box>
      </template>
      </edit-data-table>
      <div class="form-bottom-box">
        <el-button :loading='taskLoading' type="primary" @click="saveTaskData">保存</el-button>
        <el-button :loading='taskLoading' @click="addTaskDialog = false">取消</el-button>
      </div>
      </drag-dialog>
    <data-box
      v-if="flag"
      :multiple="false"
      :props='{ label: "milestoneName", value: "milestoneNode"}'
      :tableColumn="dataBoxHead"
      hostUrl="/projectDelivery/listProjectMilestone"
      :extendParms="params"
      @confirm="val => { getContent(val) }"
      ref="dynamicDataBox"
    ></data-box>
  </div>
</template>

<script>
import FoldedPanel from "@/components/FoldedPanel";
import DragDialog from '@/components/DragDialog'
import PersonStep from "@/components/PersonStep";
import { getFlowNode } from "@/api/hrApproval"
import "@/components/dynamic-form";
import "@/components/EditDataTable";
import { addPlan, planDetails, planNodeList,setSurer, delDetailPlan, getBizProjectPlanChange } from "@/api/bill/ProjectPlan";
import { getProjectDelivery } from "@/api/basic";
import { parseTime, deepClone } from "@/utils";
import { downLoad, delFile } from '@/api/bill/contract'
import { getDocumentCode } from '@/views/utils'
import DataBox from "@/components/dynamic-form/dynamic-data-box";
import CrudMixin from "@/mixins/CrudMixin";
import { tableSataus } from '@/views/bill/mixins/status'
import { getToken } from "@/utils/auth";
import { saveBath, getByProjectNode, delTask } from '@/api/bill/assignment'
import { get } from "@/api/dictDetail";
const currentTime = new Date();
currentTime.setDate(0)
currentTime.setHours(23)
currentTime.setSeconds(59)
currentTime.setMinutes(59)

export default {
  name: 'NewPlanForm',
  components: {
    FoldedPanel,
    DataBox,
    DragDialog,
    PersonStep,
    // DynamicBox
  },
  mixins: [CrudMixin, tableSataus],
  data () {
    return {
      params: {id: ''},
      flag: false,
      dataBoxHead: [
        { label: "编码", property: "code" },
        { label: "名称", property: "milestoneName" },
        { label: "备注", property: "remark" }
      ],
      uploadHeaders: {},
      actionUrl: `${process.env.VUE_APP_BASE_API}/attachment/masterdata/fileUpload`,
      fileId: [], // 文件上传
      fileList: [],
      preNodeList: [],
      keyOutsListArr: [],
      id: "",
      isEdit: false,
      loading: false,
      toolBarShow: false,
      form: { deliveryId: '' },
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "documentNum",
            label: "单据编号",
            value: "",
            span: 8,
            disabled: true
          },
          {
            type: "databox",
            key: "projectNum",
            label: "项目号",
            placeholder: "请选择项目",
            value: "",
            span: 8,
            props: {
              label: "projectNumber",
              value: "id"
            },
            url: "/projectDelivery",
            tableColumn: [
              {
                property: "projectNumber",
                label: "项目号",
              },
              {
                property: "projectName",
                label: "名称",
                query: {
                  type: "input"
                }
              },
              {
                property: "personManager",
                label: "项目负责人",
                formatter: personManager => { return personManager ? personManager.name : '' }
              },
            ],
            events: {
              change: (val) => {
                if (val.bsProject && val.bsProject.customer) {
                  this.form.projectCustomerName = val.bsProject.customer.name || ''
                }
              }
            },
            extendParms: { billState: 3, searchType: 2 },
            multiple: false,
            disabled: Boolean(this.$route.query.id), // 编辑状态不允许修改项目
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }]
          },
          {
            type: "date",
            key: "planDate",
            label: "提交日期",
            valueFormat: "yyyy-MM-dd",
            defaultValue: new Date(),
            span: 8,
            disabled: true
          },
          {
            type: "input",
            key: "totals",
            label: "成本合计",
            span: 8,
            disabled: true
          },
          {
            type: "input",
            key: "costForecast",
            label: "人工成本预算",
            span: 8,
            disabled: true
          },
          {
            type: "input",
            key: "projectCustomerName",
            label: "终端客户",
            span: 8,
            disabled: true
          },
          // {
          //   type: "date",
          //   key: "modified",
          //   label: "最后修改日期",
          //   placeholder: "最后修改日期",
          //   value: "",
          //   valueFormat: "yyyy-MM-dd",
          //   span: 8
          // }
        ]
      },
      tableHead: [
        {
          label: "节点编号",
          prop: "code",
          align: "center",
          width: "100",
          editRender: {
            type: "default",
            name: "ElInput"
          }
        },
        {
          label: "项目阶段",
          prop: "milestoneNodeEntity.bsMilestoneNode.name",
          align: "center",
          width: "120",
        },
        {
          label: "阶段描述",
          prop: "milestoneNodeEntity.remark",
          align: "center",
          width: "120",
        },
        {
          label: "项目节点",
          prop: "projectNodeEntity",
          align: "center",
          width: "120",
          editRender: { type: "default", }
        },
        {
          label: "节点描述",
          prop: "taskNodeDescription",
          align: "center",
          width: "120",
          editRender: {
            type: "default",
            name: "ElInput"
          }
        },
        {
          label: "成本预估",
          prop: "costEstimation",
          align: "center",
          width: "120",
          editRender: {
            type: "default",
            name: "ElInputNumber",
            props: {
              controls: false,
            }
          }
        },
        {
          label: "关键输出物",
          prop: "keyOutObjectEntity",
          align: "center",
          width: "120",
          editRender: { type: "default", }
        },
        {
          label: "备注",
          prop: "remark",
          align: "center",
          minWidth: "150",
          editRender: {
            type: "default",
            name: "ElInput"
          }
        },
        {
          label: "最后修改人",
          prop: "modifierName",
          align: "center",
          width: "105",
        },
        {
          label: "最后修改时间",
          prop: "modified",
          align: "center",
          width: "145",
        },
        {
          label: "任务状态",
          prop: "surer",
          align: "center",
          width: "95",
          formatter: (cellVal) => {
            if (cellVal === 2) {
              return '已完成'
            } else {
              return '进行中'
            }
          }
        }
      ],
      tableData: [],
      projectStage: [
        { label: "项目阶段名称", property: "bsMilestoneNode.name", query: { type: "input" } },
        { label: "预计开始时间", property: "expectedStartTime", },
        { label: "最晚完成时间", property: "latestFinishTime" },
        { label: "工作描述", property: "workTargetDetail" }
      ],
      headLevels: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ],
      headPrev: [
        { label: "编码", property: "code", query: { type: "input" } },
        { label: "预计开始时间", property: "predictStartTime" },
        { label: "最晚完成时间", property: "lastCompletionTime" },
        { label: "项目阶段", property: "milestoneNodeName" },
      ],
      projecdNodeHead: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "是否里程碑节点", property: "whetherMilepostNode", formatter: (val) => { return val ? '是' : '否' } },
        { label: "是否重点关注节点", property: "whetherFocusNode", formatter: (val) => { return val ? '是' : '否' } },
        { label: "是否考核节点", property: "whetherCheckNode", formatter: (val) => { return val ? '是' : '否' } },
        { label: "备注", property: "remark" }
      ],
      projectNumber: '',
      validRules: {
        projectNodeEntity: [{ required: true, message: "不能为空", trigger: "blur" }],
        taskNodeDescription: [{ required: true, message: "不能为空", trigger: "blur" }],
        costEstimation: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
      validateRefNames: ['form', 'planTable'],
      stepShow: false,
      personStepData: [],
      assignData: {},
      hasDelete: false,
      changeHead: [],
      tableChangeData: [],
      addTaskDialog: false,
      taskHead: [
        {
          label: "任务名称",
          prop: "name",
          align: "center",
          editRender: {
            type: "default",
            name: "ElInput"
          }
        },
        {
          label: "人员",
          prop: "taskReceiverPerson",
          align: "center",
          editRender: {
            type: "default",
          }
        },
        {
          label: "任务内容",
          prop: "taskContent",
          align: "center",
          editRender: {
            type: "default",
            name: "ElInput"
          }
        },
        {
          label: "任务类型",
          prop: "taskType",
          align: "center",
          editRender: {
            type: "default",
            name: "ElSelect",
            options: []
          },
          formatter: (val) => {
            if (typeof val !== 'object') {
                return val ? this.taskTypeDict.find(i => i.value === val).label : ''
            }
            return val
          }
        },
        {
            label: "任务开始时间",
            prop: "plannedStartTime",
            formatter: this.formatter,
            editRender: {
              name: "ElDatePicker",
              props: { type: "date", valueFormat: "timestamp" },
            }
        },
        {
            label: "任务结束时间",
            prop: "plannedEndTime",
            formatter: this.formatter,
            editRender: {
              name: "ElDatePicker",
              props: { type: "date", valueFormat: "timestamp" }
            }
        },
        {
          label: "可支配人天",
          prop: "disposableHumanNature",
          align: "center",
          editRender: {
            type: "default",
            name: "ElInputNumber",
            props: {
              controls: false,
              min: 0,
              max: 5
            }
          }
        },
        {
          label: "实际确认人天",
          prop: "actualHumanNature",
          align: "center"
        },
      ],
      taskData: [],
      taskvalidRules: {
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        taskReceiverPerson: [{ required: true, message: "不能为空", trigger: "change" }],
        taskReceiver: [{ required: true, message: "不能为空", trigger: "change" }],
        taskContent: [{ required: true, message: "不能为空", trigger: "blur" }],
        taskType: [{ required: true, message: "不能为空", trigger: "change" }],
        plannedStartTime: [{ required: true, message: "不能为空", trigger: "change" }],
        plannedEndTime: [{ required: true, message: "不能为空", trigger: "change" }],
        disposableHumanNature: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
      persionNodeHead: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
      ],
      validateRefTask: ['taskTable'],
      taskLoading: false,
      taskFrom: {},
      taskTypeDict: [],
    }
  },
  watch: {
    'form.projectNum': {
      handler (val) {
        if (val) {
          this.projectNumber = val.projectNumber
          if (val.id && !this.id) {
            planNodeList({ id: val.id }).then(res => {
              this.tableData = [];
              res.data.forEach((i, o) => {
                this.tableData.push({ code: i.code ? i.code + '.01' : `${o + 1}.01`,costEstimation: i.planCost, milestoneNodeEntity: { bsMilestoneNode: i.bsMilestoneNode }, milestoneNode: i.id, taskNodeDescription: i.workTargetDetail })
              })
            })

            getProjectDelivery(val.id).then(res => {
              this.form.costForecast = res.data.projectDelivery.costForecast;
            })
          }
        } else {
          this.tableData = []
        }
      },
      deep: true
    },
    tableData: {
      handler (val) {
        let sum = 0;
        val.forEach(ele => {
          sum += Number(ele.costEstimation);
        });
        this.form.totals = sum.toFixed(2);
        this.preNodeList = this.tableData.reduce((prev, cur) => {
          if (cur.code) {
            prev.push({ code: `${cur.code}`, predictStartTime: cur.predictStartTime, lastCompletionTime: cur.lastCompletionTime, milestoneNodeName: cur.milestoneNodeEntity.bsMilestoneNode.name })
            return prev
          } else {
            return prev
          }
        }, [{ code: '无', predictStartTime: '无', lastCompletionTime: '无', milestoneNodeName: '无' }])
      },
      deep: true
    },
    addTaskDialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.getTaskList()
        })
      }
    }
  },
  computed: {
    canSave() {
      return this.isEdit && (!this.form.billState || this.form.billState === 1) && !this.tableChangeData.length
    },
    canEdit() {
      // 有权限操作
      if (this.form.possess) {
        return this.form.possess === 2
      }
      return true
    },
    canAddNode() {
     return !!this.id
    },
    taskPersonCode() {
      return {projectCode: this.form.projectNum.projectNumber}
    }
  },
  created () {
    this.uploadHeaders = { Authorization: `Bearer ${getToken()}` }
    this.getTaskDict('task_package')
    this.id = this.$route.query.id;
    this.isEdit = Boolean(parseInt(this.$route.query.isEdit));
    if (this.id) {
      planDetails(this.id).then(res => {
        if (res.code === 200) {
          const form = res.data.bizProjectPlan;

          form.projectNum = { id: form.deliveryId, projectNumber: form.projectNum };
          form.costForecast = res.data.costForecast;
          this.form = form;
          if (form.project && form.project.customer) {
            this.form.projectCustomerName = form.project.customer.name || ''
          }
          this.tableData = res.data.bizProjectPlanEntries;

          this.tableData.forEach((item, index) => {
            item.keyOutsListArr = item.keyOutsList
          });

          this.fileId = res.data.bizAttachmentList == null ? [] : res.data.bizAttachmentList
        }
      });
      getBizProjectPlanChange(this.id).then(res => {
        if (res.code === 200) {
          this.tableChangeData = res.data.bizProjectPlanChanges
          this.changeHead = deepClone(this.tableHead)
          this.changeHead.pop()
          if (this.isEdit) {
            this.changeHead.splice(0,1)
          }
        }
      });
    } else {
      this.form.documentNum = getDocumentCode('XMJH');
    }

    if (this.isEdit) {
      this.tableHead.unshift({ label: '插入', prop: 'insert' })
    }
  },
  methods: {
    // 任务分解
    taskDecomposition(scope) {
      this.taskFrom = {
        projectCode: this.form.projectNum.projectNumber,
        projectNode: scope.row.id,
        nodecode: scope.row.code,
        taskState: 'D',
      }
      this.addTaskDialog = true
    },
    // 任务分解删除按钮
    delTaskDetails(scope) {
      if (scope.row.id) {
        delTask(scope.row.id).then(res => {
          if (res.code === 200) {
            this.taskData.splice(scope.$index, 1)
            this.$notify({ title: "删除成功！", type: "success", duration: 2500 });
          }
        })
      } else {
        this.$refs.taskTable.deleteRows(scope.row);
      }
      this.$refs[scope.$index + 'task'].doClose()
    },
    // 任务分解详情列表
    getTaskList() {
      this.taskData = []
      const params = {
        projectNode: this.taskFrom.projectNode,
        projectCode: this.taskFrom.projectCode,
      }
      this.taskLoading = true
      getByProjectNode(params).then(res => {
        if (res.code === 200) {
          this.taskLoading = false;
          this.taskData = res.data
        }
      }).catch(e => { this.taskLoading = false; });
    },
    // 任务分解保存
    saveTaskData() {
      if (!this.taskData.length) {
        return this.$notify({ title: "未分解任务!", type: "error", duration: 2500 });
      }
      this._validateForm(this.validateRefTask).then(() => {
        for (const i of this.taskData) {
          if (i.plannedStartTime > i.plannedEndTime) {
            return this.$notify({ title: "任务结束时间不能小于任务开始时间！", type: "error", duration: 2500 });
          }
        }
        const params = this.taskData.map(j => {
          return Object.assign(j, this.taskFrom)
        })
        this.taskLoading = true
        saveBath(params).then(res => {
          if (res.code === 200) {
            this.taskLoading = false;
            this.addTaskDialog = false
            return this.$notify({ title: "保存成功。", type: "success", duration: 2500 });
          }
        }).catch(e => { this.taskLoading = false; });
      }).catch(e => { this.taskLoading = false; })
    },
    // 获取任务类型字典项
    getTaskDict(code) {
      get(code).then(res => {
          if (res.code === 200) {
            this.taskTypeDict = res.data
            this.$set(this.taskHead[this.taskHead.findIndex(i => i.prop === "taskType")].editRender,'options',res.data)
          }
        }).catch(e => { this.taskLoading = false; });
    },
    formatter(val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
    activeMethod({ row, rowIndex, column, columnIndex }) {
       // surer 1可编辑 2不可编辑 调整状态并且当前日期大于任务时间才可以编辑
       if (row.surer === 2) {
         return false
       }
      return true
    },
    // 任务分解是否可编辑这行
    taskActiveMethod({ row, rowIndex, column, columnIndex }) {
      if (row.id) {
        return false
      }
      return true
    },
    primaryList(id,val) {
      setSurer({surer: 2},id).then(res => {
        if (res.code === 200) {
          this.$nextTick(() => {
            this.$set(this.tableData[val.$index],'surer',2)
          })
          this.$refs[val.$index + 'b'].doClose()
        }
      });
    },
    // 插入行
    insertRow (scope) {
      const firstCode = scope.row.code.split('.')[0]
      let sameIndex, secondCode
      for (let i = scope.$index; i <= this.tableData.length; i++) {
        if (i === this.tableData.length || this.tableData[i].code.split('.')[0] !== firstCode) {
          secondCode = this.tableData[i - 1].code.split('.')[1]
          sameIndex = i
          break
        }
      }
      secondCode = parseInt(secondCode) + 1
      if (secondCode < 10) {
        secondCode = '0' + secondCode
      }
      this.tableData.splice(sameIndex, 0, {
        code: firstCode + '.' + secondCode,
        milestoneNodeEntity: scope.row.milestoneNodeEntity,
        milestoneNode: scope.row.milestoneNode,
        predictStartTime: scope.row.predictStartTime,
        lastCompletionTime: scope.row.lastCompletionTime,
      })
    },
    handleSuccess (res) {
      if (res.code === 200) {
        this.$notify({ title: "上传成功！", type: "success", duration: 1500 });
        this.fileId.push(res.data)
      }
    },
    handleRemove (file, fileList) {
      delFile(file.id).then(res => {
        this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
        this.fileId = fileList
      })
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    preview (file) {
      downLoad(file.id, file.name)
    },
    upStatus (val) {
      this.$refs.planTable.$refs.elTable.revert(val.row)
    },
    addPlan (data) {
      addPlan(data).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.$notify({
            title: '操作成功！',
            type: 'success',
            duration: 2500
          })
          if (data.bizProjectPlan.billState === 1) {
            // 保存
            const { path } = this.$route
            this.$store.dispatch('tagsView/delCachedView', this.$route).then(() => {
              this.$router.replace({
                path: '/redirect' + `${path}?id=${res.data.bizProjectPlan.id}&isEdit=1`
              })
            })
          } else {
            this.cancel()
          }
        }
      }).finally(() => {
        this.$nextTick(() => {
          if (this.$refs.personStepRef) {
            this.$refs.personStepRef.loadActivitySubmit = false
          }
        })
        this.loading = false;
      });
    },
    // 保存
    save () {
      this.loading = true
      this.addPlan(this.getFormData())
    },
    // 判断是否有重复的节点编号
    isRepeat (arr) {
      const hash = {};
      for (const i in arr) {
        if (hash[arr[i]]) {
          return true;
        }
        hash[arr[i]] = true;
      }
      return false;
    },
    // 提交
    submit () {
      this.loading = true
      const that = this;
      this._validateForm(this.validateRefNames).then(() => {
        that.loading = true
        // 判断有没有变更列表信息或者新增信息
        if (!that.canSave) {
          let isProp = false
          that.tableData.forEach(e => {
            e.id ? isProp = true : isProp = false
          });
          if (!this.$refs.planTable.$refs.elTable.getUpdateRecords().length && isProp && !this.hasDelete) {
            that.$notify({ title: "当前没有变更信息", type: "error", duration: 1500 });
            that.loading = false;
            return false;
          }
        }
        if (process.env.VUE_APP_IS_AUDIT === 'no') { // 判断是否需要走审批
          this.$confirm('请确认是否提交?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true
            const that = this;
            const nodeArray = []
            for (let i = 0; i < that.tableData.length; i++) {
              nodeArray.push(that.tableData[i].code);
            }
            if (that.isRepeat(nodeArray)) {
              that.$notify({ title: "存在重复的节点编号", type: "error", duration: 1500 });
              that.loading = false;
              return false;
            }
            const params = that.getFormData(2)
            if (!params.bizProjectPlanEntries.length) {
              that.$notify({ title: "没有要提交的当月详细计划节点", type: "error", duration: 1500 });
              that.loading = false;
              return false;
            }
            params.bizProjectPlan.billState = 3
            that.addPlan(params)
            that.loading = false
          }).catch(() => {
            this.loading = false
          });
        } else {
          getFlowNode({ from: "task_node_process", id: that.form.id }).then(res => {
            this.loading = false;
            this.personStepData = [];
            if (res.code === 200) {
              this.stepShow = true;
              this.personStepData = res.data;
              this.$nextTick(() => {
                this.$refs.personStepRef.formFlag = 'task_node_process'
              })
            }
          }).finally((res) => {
            this.loading = false
            that.$notify({ title: res.msg, type: "error", duration: 1500 });
          })
        }
      }).catch(e => {
        that.$notify({ title: '' + e, type: "error", duration: 1500 });
        that.loading = false;
      })
    },
    submitConfirm(val) {
      this.loading = true
      const that = this;
      const nodeArray = []
      for (let i = 0; i < that.tableData.length; i++) {
        nodeArray.push(that.tableData[i].code);
      }
      if (that.isRepeat(nodeArray)) {
        that.$notify({ title: "存在重复的节点编号", type: "error", duration: 1500 });
        that.loading = false;
        return false;
      }
      // 组装审批人id
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      this.assignData = obj2
      const params = that.getFormData(2)
      if (!params.bizProjectPlanEntries.length) {
        that.$notify({ title: "没有要提交的当月详细计划节点", type: "error", duration: 1500 });
        that.loading = false;
        return false;
      }
      that.addPlan(params)
      that.loading = false
    },
    cancel () {
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.go(-1);
    },
    statusFilter (val) {
      const arr = this.tableHead.filter(ele => ele.prop === "taskStatus");
      if (arr.length) {
        const labelArr = arr[0].editRender.options.filter(ele => ele.value === val);
        if (labelArr.length) {
          return labelArr[0].label;
        }
      }
    },
    // 组装提交数据
    getFormData (status = 1) {
      const submitForm = { ...this.form }
      if (this.form.projectNum) {
        submitForm.deliveryId = this.form.projectNum.id;
        submitForm.projectNum = this.form.projectNum.projectNumber;
      }
      this.form.planDate = parseTime(new Date(), '{y}-{m}-{d}');
      // if (status === 2) { // 提交日期
      submitForm.planDate = parseTime(new Date(), '{y}-{m}-{d}');
      // }
      submitForm.billState = status;
      const form = deepClone(submitForm);
      // if (this.id && this.isEdit && !this.canSave) { // 当修改时详细计划分录需筛选出修改过的数据
      //   return {
      //     bizProjectPlan: form,
      //     bizProjectPlanEntries: this.$refs.planTable.$refs.elTable.getUpdateRecords(),
      //     // bizProjectPlanEntries: this.$refs.planTable.$refs.elTable.getUpdateRecords().filter(i => i.completionTime === parseTime(nextDate, "{y}-{m}")),
      //     // bizProjectPlanEntries: this.tableData.filter(i => {
      //     //   return Date.parse(i.completionTime) > currentTime.getTime()
      //     // }),
      //     bizAttachmentList: this.fileId,
      //     assignData: JSON.stringify(this.assignData),
      //     from: 'task_node_process'
      //   }
      // }
      return {
        bizProjectPlan: form,
        bizProjectPlanEntries: this.tableData,
        bizAttachmentList: this.fileId,
        assignData: JSON.stringify(this.assignData),
        from: 'task_node_process'
      }
    },
    // 是否显示删除按钮
    showDel (scope) {
      // this.isEdit 是否可编辑
      //  scope.row.surer 是否确认 1没有 2确认
      //  scope.row.quotes 是否被引用 1没有 2引用
      //  (scope.row.completionTime && Date.parse(scope.row.completionTime) <= currentTime.getTime()) 判断时间
      if (this.canSave) {
        return true
      }
      if (this.isEdit && scope.row.surer !== 2 && scope.row.quotes !== 2) {
        // if (scope.row.completionTime && Date.parse(scope.row.completionTime) <= currentTime.getTime()) {
        //   return false
        // }
        return true
      }
      return false
    },
    // 单个删除详细计划
    delMilestonePlans (id, scope) {
      if (id) {
        const data = this.tableData.filter(i => i.milestoneNodeEntity.bsMilestoneNode.name === scope.row.milestoneNodeEntity.bsMilestoneNode.name)
        if (data.length <= 1) {
          this.$notify({ title: "同一项目阶段不能少于一条", type: "error", duration: 1500 });
          return  false
        }
        if (this.canSave) {
          delDetailPlan(id).then(res => {
            this.$refs[scope.$index + 'a'].doClose()
            if (res.code === 200) {
              this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
              this.tableData.splice(scope.$index, 1);
              this.hasDelete = true
            } else {
              this.$notify({ title: res.msg, type: "error", duration: 1500 });
            }
          })
        } else {
          this.$refs[scope.$index + 'a'].doClose()
          this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
          this.tableData.splice(scope.$index, 1);
          this.hasDelete = true
        }
      } else {
        this.$refs.planTable.deleteRows(scope.row)
        this.$refs[scope.$index + 'a'].doClose()
      }
    },
    // 新增阶段
    addNode() {
      if (!this.projectNumber) {
        return this.$notify({ title: "请选择项目！", type: "error", duration: 1500 });
      }
      this.params.id = this.form.projectNum.id
      this.flag =  true
      setTimeout(() => {
        this.$refs.dynamicDataBox.open();
      },500)
    },
    getContent(val) {
      console.log(val)
      if (this.tableData.findIndex(i => i.milestoneNode === val.id) !== -1) {
        return this.$notify({ title: "列表存在改阶段！", type: "error", duration: 1500 });
      }
      const end = this.tableData[this.tableData.length - 1]
      const newCode =  `${Number(end.code.slice(0, 1)) + 1}.01`
      this.tableData.push({ code: newCode,costEstimation: val.planCost,
        pid: this.form.id,milestoneNodeEntity: { bsMilestoneNode: val.bsMilestoneNode },
        milestoneNode: val.id, taskNodeDescription: val.workTargetDetail })
    },
  }
};
</script>

<style lang="scss" scoped>
.el-upload-list__item {
  width: 30%;
}
.file-box {
  margin-top: 10px;
  display: flex;
  position: relative;
  padding: 10px;
  .file-item {
    position: relative;
    margin-right: 14px;
    .file-close {
      position: absolute;
      left: 0px;
      top: -6px;
      font-size: 14px;
    }
  }
}
.btn-warp {
  padding-top: 20px;
  text-align: right;

  .btn-submit {
    width: 80px;
    height: 38px;
    background: #1369a8;
    color: white;
  }

  .btn-cancel {
    width: 80px;
    height: 38px;
    background: #fff;
  }
}
.add-project{
  float: right;
  margin: 15px;
}
.form-bottom-box{
  text-align: right;
  margin-top: 15px;
}
</style>
